import React, { useLayoutEffect, useState } from "react";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino.js";
import { useDispatch } from "react-redux";
import { setLiveGames } from "../../store/gamesSlice.js";
import GamesItems from "../mui/games_items/GamesItems.jsx";

// ПРОВЕРИТЬ
export default function LiveGames() {
  const dispatch = useDispatch();
  const games = useAppSelector((state) => state.games.liveGames);
  const listId = useAppSelector((state) => state.games.idProvidersLiveGame);
  const gamesLength = games.length;
  const [loader, setLoader] = useState(false);
  const [noGames, setNoGames] = useState(false);

  useLayoutEffect(() => {
    if (gamesLength || !listId.length) {
      return;
    }

    setLoader(true);
    const promises = listId.map((providerId) =>
      API_CASINO.list.providerGames({ providerId: +providerId })
    );

    Promise.all(promises)
      .then((results) => {
        const allGames = results.flatMap((res) => res.data.list);
        dispatch(setLiveGames(allGames));
      })
      .catch(console.error)
      .finally(() => {
        setLoader(false);
        setNoGames(true);
      });
  }, [gamesLength, listId]);

  return <GamesItems games={games} loader={loader} noGames={noGames} />;
}
